export default __webpack_public_path__ + "static/media/logo-vallecas.0a226dd9.svg";